import { useMemo } from 'react';

import { Card, CardHeader } from '@/components/core/card';
import { DataTable, useDataTable } from '@/components/data-table';
import { DataTableCardBody, DataTableCardTitle } from '@/components/data-table/data-table-card';

import { getAsnLineColumns, type AsnLine, type AsnLineRow } from './asn-lines-card-columns';

type AsnLinesCardProps = {
  title: string;
  lines: AsnLine[];
  isLoading?: boolean;
  isLoadingWithStaleData?: boolean;
  hasError?: boolean;
  showQtyReceived?: boolean;
};

export function AsnLinesCard({
  title,
  lines,
  isLoading,
  isLoadingWithStaleData,
  hasError,
  showQtyReceived,
}: AsnLinesCardProps) {
  const columns = useMemo(() => getAsnLineColumns({ showQtyReceived }), [showQtyReceived]);

  const table = useDataTable<AsnLineRow>({
    data: lines,
    columns,
    isLoading,
    isLoadingWithStaleData,
    hasError,
    // This card has no pagination controls, so opt out of client pagination — otherwise
    // TanStack's default 10-row page size silently hides rows.
    manualPagination: true,
    manualSorting: false,
  });

  return (
    <Card aria-label={title}>
      <CardHeader>
        <DataTableCardTitle table={table}>{title}</DataTableCardTitle>
      </CardHeader>
      <DataTableCardBody table={table} emptyMessage="No items found">
        <DataTable table={table} />
      </DataTableCardBody>
    </Card>
  );
}
